import { gql } from '@apollo/client';

// One policy's billing, for the condensed layout's household Billing tab. The policy page reads the
// same fields through GET_ACCOUNT_POLICY into the one-policy store; this tab runs one of these per
// policy instead.
export const GET_POLICY_BILLING_DETAILS = gql`
  query getPolicyBillingDetails($accountId: ID!, $policyId: ID!) {
    billingDetails: getBillingDetails(accountId: $accountId, policyId: $policyId) {
      nextPaymentDate
      nextPaymentAmount
      nextPaymentTotal
      totalRemaining
      nextPayments {
        date
        remainingMonthly
        transactionFee
        total
      }
      activePaymentMethod {
        id
        brand
        last4
        bankName
        type
      }
      allPaymentMethods {
        id
        brand
        last4
        bankName
        expMonth
        expYear
        type
      }
      transactions {
        id
        isRefund
        paymentAmount
        paymentRefunded
        refundedAt
        paymentDate
        paymentMethod
        paymentMethodBrand
        paymentMethodLast4
        paymentStatus
        internalDescription
      }
      refundTransactions {
        id
        isRefund
        paymentRefunded
        refundedAt
        paymentMethod
        paymentMethodBrand
        paymentMethodLast4
        paymentStatus
        internalDescription
      }
    }
  }
`;
